<div *ngIf="isLoading" class="flex items-center justify-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div>

<div class="container px-4 py-7">
  <div class="w-full form-container">
    <div class="w-full p-6 bg-white rounded-md shadow-lg">
      <h2 class="mb-4 text-2xl font-bold">Edit Subscription</h2>
      <div class="w-full">
        <label
          for="customer"
          class="block mt-3 mb-3 text-sm font-medium text-gray-700 font-raleway">
          Customer
        </label>
        <p-autocomplete
          id="customer"
          [(ngModel)]="selectedCustomer"
          optionLabel="name"
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md"
          [suggestions]="filteredCustomers"
          (completeMethod)="searchCustomers($event)" />
      </div>
      <div class="w-full">
        <label
          for="plan"
          class="block mt-3 mb-3 text-sm font-medium text-gray-700 font-raleway">
          Service Plan
        </label>
        <p-autocomplete
          id="plan"
          [(ngModel)]="selectedPlan"
          optionLabel="name"
          [suggestions]="filteredServicePlans"
          (completeMethod)="searchServicePlans($event)"
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
      </div>
      <div class="w-full">
        <label
          for="name"
          class="block mt-3 mb-3 text-sm font-medium text-gray-700 font-raleway">
          Name
        </label>
        <input
          pInputText
          id="name"
          [(ngModel)]="name"
          class="w-full mt-1"
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
      </div>
      <div class="w-full">
        <label
          for="plan"
          class="block mt-3 mb-3 text-sm font-medium text-gray-700 font-raleway">
          Activation Date
        </label>
        <p-datepicker
          [(ngModel)]="activationDate"
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
      </div>
      <div class="w-full">
        <label
          for="plan"
          class="block mt-3 mb-3 text-sm font-medium text-gray-700 font-raleway">
          Next Due
        </label>
        <p-datepicker
          [(ngModel)]="nextDue"
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
      </div>
      <div class="w-full">
        <label
          for="month"
          class="block mt-3 mb-3 text-sm font-medium text-gray-700 font-raleway">
          Months to Bill
        </label>
        <input pInputText id="months" [(ngModel)]="months" class="w-full mt-1" 
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
      </div>
      <div class="w-full">
        <label
          for="actulAmount"
          class="block mt-3 mb-3 text-sm font-medium text-gray-700 font-raleway">
          Actual Amount
        </label>
        <input pInputText id="actulAmount" [(ngModel)]="actualAmount" class="w-full mt-1" 
          class="w-full p-3 text-base text-gray-700 border border-gray-300 rounded-md" />
      </div>

      <div class="flex justify-start py-4">
        <button pButton (click)="onSubmit()" class="rounded-md primary-btn">
          Update
        </button>
      </div>
    </div>
  </div>
</div>
